import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function MobileCTABar() {
  return <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-3 z-50 shadow-[0_-4px_10px_rgba(0,0,0,0.05)]" data-id="element-115">
      <div className="flex gap-3" data-id="element-116">
        <a href="tel:9159795151" className="flex-1" data-id="element-117">
          <Button variant="outline" className="w-full h-12 rounded-xl border-2 border-brand-navy text-brand-navy font-bold text-base" data-id="element-118">
            <Phone className="w-4 h-4 mr-2" data-id="element-119" />
            Call Now
          </Button>
        </a>
        <a href="#quote" className="flex-1" data-id="element-120">
          <Button className="w-full h-12 rounded-xl brand-gradient text-white font-bold text-base border-0" data-id="element-121">
            Book Now
          </Button>
        </a>
      </div>
    </div>;
}